import { ModulesMap, ModulesConfigMap } from "../data/modulesMaps"

export default {
	createCompany: {
		useCache: false,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.COMPANY].CREATE_COMPANY,
	},
	getCompanyProfile: {
		useCache: false,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.COMPANY].GET_COMPANY,
	},
	updateCompanyProfile: {
		useCache: false,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.COMPANY].PATCH_COMPANY,
	},
	getUserCompanyPermission: {
		useCache: false,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.COMPANY].GET_AVAILABLE_USER_COMPANY_PERMISSIONS,
	},
}
